export interface EnvironmentConfig {
  /** Whether the application is running in production mode */
  production: boolean;
  /** Whether the application has a support provider */
  hasSupportProvider: boolean | null;
  /** Whether the application has LLM service enabled */
  hasLLMService: boolean | null;
  /** Whether the application has payments enabled */
  hasPaymentsEnabled: boolean | null;
  /** Whether the application has an email provider */
  hasEmailProvider: boolean | null;
  /** List of authentication provider names */
  authProviderNames: string[];
  /** PostHog API key */
  posthogApiKey: string | null;
  /** Base URL for the main API */
  baseUrl: string;
  /** WebSocket URL for the machine server/gateway */
  machineServerUrl: string;
  /** URL for the client application */
  clientAppUrl: string;
  /** URL for the storage gateway */
  storageGatewayUrl: string | null;
  /** Base URL for the live-activity (ActivityMonitor) service */
  activityMonitorUrl: string;
}

// Extend Window interface to include environment property
declare global {
  interface Window {
    environment?: EnvironmentConfig;
  }
}

export function parseBooleanEnv(name: string): boolean | null {
  const value = ((window as any)?.__RUNTIME_CONFIG__?.[name] ?? '')?.trim()?.toLowerCase();
  return value === 'true' ? true : value === 'false' ? false : null;
}

export function parseStringArrayEnv(name: string): string[] {
  const value = ((window as any)?.__RUNTIME_CONFIG__?.[name] ?? '')?.trim();

  if (typeof value !== 'string') {
    return [];
  }

  switch (value?.toLowerCase()) {
    case null:
    case 'none':
    case 'null':
    case '':
    case 'unknown':
    case 'undefined':
      return [];
  }

  return value
    .split(',')
    .map((item) => item.trim())
    .filter((item) => item.length > 0);
}
